module.exports = __webpack_public_path__ + "img/50_30.f7e41bf5.png";